// src/data/projectContent.js

const stoProofOfTitleProject = [
  {
    title: "Prueba de Título y Verificación de Propiedad en un Smart Contract",
    value: `
## Verificación de Título de Propiedad

Este módulo del proyecto aborda cómo **verificar la prueba de titularidad** de los activos que se van a tokenizar mediante un contrato inteligente.

En muchos países, los **registros de propiedad inmobiliaria y accionaria** están disponibles en línea, provistos y mantenidos por **fuentes gubernamentales confiables**.

> Estos datos se actualizan regularmente y son considerados una fuente válida y verificable para integrar en blockchain.

---

## Integración con el Contrato Inteligente

Al copiar la información legal de titularidad desde estas fuentes gubernamentales y registrarla en un contrato inteligente desplegado en Ethereum:

- El token queda **marcado de forma irreversible** como representación del activo específico (por ejemplo, un inmueble o participación empresarial).
- El contrato se convierte en una **prueba de propiedad sellada con marca de tiempo** en blockchain.

---

## Verificación Pública y Notarización

Cualquier persona con la dirección del contrato podrá:

- Comparar los registros on-chain con documentos off-chain como escrituras, títulos, acciones, etc.
- Confirmar que ambos coinciden y que la propiedad está debidamente documentada.

Los documentos también pueden ser **notarizados por despachos legales o contables**, quienes los certifican mediante firma y sello, y luego estos pueden ser integrados al historial de transacciones del contrato.

---

## Inmutabilidad de los Registros

Una vez incorporados:

- Todos los **documentos dentro del contrato** y las transacciones asociadas en blockchain son permanentes.
- No pueden ser modificados ni eliminados, lo que **garantiza la trazabilidad y transparencia legal**.

---

## Requisitos para Probar la Titularidad

Para establecer la prueba de propiedad de un activo, el proyecto requiere:

- Que el activo esté **registrado ante la autoridad competente**, ya sea inmobiliaria, mercantil o similar.
- O bien, que esté **certificado por una entidad de confianza**, como un bufete de abogados o contadores.

Si no es posible un registro oficial, el proyecto admite como alternativa válida una **certificación notarial formal**.

---

## Aplicación en el Proyecto

El ejemplo de prueba de propiedad ya está incluido dentro de las **plantillas editables del proyecto**. Estas serán integradas en el contrato inteligente durante las siguientes etapas, donde:

- Se insertará el contrato off-chain dentro del smart contract.
- Se desplegará en la red Ethereum (modo prueba con Ropsten).

---

## Consideraciones Finales

Antes de proceder a integrar cualquier documento, es imprescindible que:

- Todos los archivos sean **revisados por profesionales legales y contables**.
- El proceso de verificación se complete correctamente antes de su despliegue en red principal.

Gracias por continuar con este módulo del proyecto.
    `,
  },
];

export default stoProofOfTitleProject;
